module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Regular.c95530e8ae28d2341c01c0fd21f9acd9.eot";